/**
 * @fileoverview
 * Top-level app route paths. Use in main.routes.ts and anywhere that builds
 * URLs to feature roots (e.g. redirects, breadcrumbs, nav).
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export const APP_ROUTE_PATHS = {
  ROOT: '',
  DASHBOARD: 'dashboard',
  CASH: 'cash',
  GOLD: 'gold',
  PACKET_INVENTORY: 'packet-inventory',
  ASSET_MANAGEMENT: 'asset-management',
  BRANCH_AUDIT: 'branch-audit',
  SCORE_CARD: 'score-card',
  SCORE_CARD_BUILDER: 'score-card-builder',
  SURVEILLANCE: 'surveillance',
  TARE_WEIGHT: 'tare-weight',
  REGISTERS_AND_STATUTORY: 'registers-and-statutory',
  ONLINE: 'online',
  REPORTS: 'reports',
  QUERY_MANAGEMENT: 'query-management',
  SETTINGS: 'settings',
  MASTERS: 'masters',
  PROFILE_VIEW: 'profile/view-profile',
  SECURITY: 'security',
  SYSTEM_CONFIGURATION: 'system-configuration',
} as const;
